<div class="header-category is-cursor-pointer text-12 text-grey-70 is-family-semiBold"
  *ngFor="let category of categories" (click)="selectOrdering(category.key)"
  [class.ordering]="ordering.key === category.key">

  <app-text>{{category.label | AsyncLang | async}}</app-text>

  <app-icon class="is-size-7" [name]="ordering.dir === 'asc' ? 'chevron-up' : 'chevron-down'"></app-icon>

</div>
